export default "__VITE_ASSET__DkAdlBVq__"